var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1Sur3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6409_9608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0812 47.9139C36.7574 47.9139 47.0335 37.7809 47.0335 25.2812C47.0335 12.7815 36.7574 2.64844 24.0812 2.64844C11.405 2.64844 1.12891 12.7815 1.12891 25.2812C1.12891 37.7809 11.405 47.9139 24.0812 47.9139Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.418698,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0812 46.1561C36.7574 46.1561 47.0335 36.0231 47.0335 23.5234C47.0335 11.0237 36.7574 0.890625 24.0812 0.890625C11.405 0.890625 1.12891 11.0237 1.12891 23.5234C1.12891 36.0231 11.405 46.1561 24.0812 46.1561Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.418698,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0812 46.1561C36.7574 46.1561 47.0335 36.0231 47.0335 23.5234C47.0335 11.0237 36.7574 0.890625 24.0812 0.890625C11.405 0.890625 1.12891 11.0237 1.12891 23.5234C1.12891 36.0231 11.405 46.1561 24.0812 46.1561Z",
    stroke: "#263238",
    strokeWidth: 0.418698,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0822 27.7349C45.4362 17.3845 38.8353 7.11214 28.3387 4.79095C17.8422 2.46977 7.42477 8.97876 5.07081 19.3292C2.71685 29.6796 9.31774 39.952 19.8143 42.2732C30.3109 44.5944 40.7283 38.0854 43.0822 27.7349Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.418698,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M43.5657 23.5269C43.5657 23.7014 43.5564 23.8714 43.5517 24.0459C26.766 19.0261 12.9983 21.5475 4.62876 24.3995C4.61478 24.1102 4.60547 23.8208 4.60547 23.5269C4.60547 21.0009 5.09917 18.5898 6.00273 16.3807C8.87642 9.31256 15.8907 4.32031 24.0879 4.32031C32.2852 4.32031 39.0665 9.15182 42.024 16.0363C43.0161 18.3372 43.5657 20.8678 43.5657 23.5269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0213 16.0363C26.8052 11.8477 14.1879 13.8134 6 16.3807C8.87369 9.31256 15.8879 4.32031 24.0852 4.32031C32.2824 4.32031 39.0638 9.15182 42.0213 16.0363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0832 5.36285C34.6651 5.36285 43.2676 13.6802 43.5517 24.0505C43.5564 23.876 43.5657 23.7014 43.5657 23.5269C43.5657 12.9178 34.8421 4.32031 24.0879 4.32031C13.3337 4.32031 4.60547 12.9178 4.60547 23.5223C4.60547 23.6968 4.61478 23.8714 4.61944 24.0459C4.90355 13.6802 13.506 5.35826 24.0879 5.35826L24.0832 5.36285Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.418698,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7431 29.4813V27.5616H15.0664V25.7107H16.7431V23.7267H15.0664V21.8759H16.7431V19.8275C16.7431 14.2704 18.69 10.8672 24.9264 10.8672C31.1628 10.8672 32.7091 14.0407 32.7091 18.6059V20.2271H26.8406V18.243C26.8406 16.6907 26.808 15.0373 24.9311 15.0373C23.0541 15.0373 22.8538 16.7229 22.8538 18.3441V21.8804H26.3423V23.7313H22.8538V25.7153H26.3423V27.5662H22.8538V30.9372C22.8538 32.7559 23.1565 34.2118 24.9311 34.2118C26.7056 34.2118 26.8406 32.5584 26.8406 30.9372V29.5502H32.7091V30.4412C32.7091 35.0063 30.9998 38.4095 24.9264 38.4095C18.853 38.4095 16.7431 34.9053 16.7431 29.4813Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.418698,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4775 28.5282V26.6085H14.8008V24.7576H16.4775V22.7736H14.8008V20.9227H16.4775V18.8744C16.4775 13.3172 18.4243 9.91406 24.6608 9.91406C30.8972 9.91406 32.4435 13.0876 32.4435 17.6527V19.274H26.575V17.2899C26.575 15.7376 26.5424 14.0842 24.6654 14.0842C22.7884 14.0842 22.5882 15.7697 22.5882 17.391V20.9273H26.0767V22.7782H22.5882V24.7622H26.0767V26.6131H22.5882V29.9841C22.5882 31.8028 22.8909 33.2587 24.6654 33.2587C26.4399 33.2587 26.575 31.6053 26.575 29.9841V28.5971H32.4435V29.4881C32.4435 34.0532 30.7342 37.4564 24.6608 37.4564C18.5874 37.4564 16.4775 33.9522 16.4775 28.5282Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.418698,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6409_9608"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.375,
    height: 47.4792,
    fill: "white",
    transform: "translate(0.894531 0.664062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1Sur3);
export default __webpack_public_path__ + "static/media/1sur3.f17217ae86fa60c88b62d49df5e5de30.svg";
export { ForwardRef as ReactComponent };